var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsCostRange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 49,
    viewBox: "0 0 65 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_9124)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2 15.65C26.47 15.25 25.71 14.92 24.91 14.63V0.73C24.91 0.33 25.24 0 25.64 0H31.94V7.75C31.94 8.15 32.27 8.48 32.67 8.48C33.07 8.48 33.4 8.15 33.4 7.75V0H39.84V7.75C39.84 8.15 40.17 8.48 40.57 8.48C40.97 8.48 41.3 8.15 41.3 7.75V0H47.74V7.75C47.74 8.15 48.07 8.48 48.47 8.48C48.87 8.48 49.2 8.15 49.2 7.75V0H55.64V7.75C55.64 8.15 55.97 8.48 56.37 8.48C56.77 8.48 57.1 8.15 57.1 7.75V0H63.4C63.8 0 64.13 0.33 64.13 0.73V15.66H27.2V15.65Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.81 31.27C36.74 27.45 35.46 23.95 33.39 21.04V17.11H39.83V23.37C39.83 23.77 40.16 24.1 40.56 24.1C40.96 24.1 41.29 23.77 41.29 23.37V17.11H47.73V23.37C47.73 23.77 48.06 24.1 48.46 24.1C48.86 24.1 49.19 23.77 49.19 23.37V17.11H55.63V23.37C55.63 23.77 55.96 24.1 56.36 24.1C56.76 24.1 57.09 23.77 57.09 23.37V17.11H64.12V31.27H36.82H36.81ZM31.93 19.3C31.17 18.5 30.36 17.77 29.49 17.12H31.93V19.3Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3793 48.35H25.7793C31.9693 45.73 36.3693 39.76 36.7693 32.73H41.7893V38.99C41.7893 39.39 42.1193 39.72 42.5193 39.72C42.9193 39.72 43.2493 39.39 43.2493 38.99V32.73H49.6893V38.99C49.6893 39.39 50.0193 39.72 50.4193 39.72C50.8193 39.72 51.1493 39.39 51.1493 38.99V32.73H57.6293V38.99C57.6293 39.39 57.9593 39.72 58.3593 39.72C58.7593 39.72 59.0893 39.39 59.0893 38.99V32.73H64.1093V47.62C64.1093 48.02 63.7793 48.35 63.3793 48.35Z",
    fill: "#DADFF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.71 48.35C7.5 48.35 0 40.88 0 31.67C0 22.46 7.5 14.96 16.71 14.96C25.92 14.96 33.38 22.46 33.38 31.67C33.38 40.88 25.88 48.34 16.71 48.34V48.35ZM16.09 41.1H11.54C11.14 41.1 10.81 40.77 10.81 40.37C10.81 39.97 11.14 39.64 11.54 39.64H17.47C19.47 39.64 21.11 38 21.11 36C21.11 34 19.47 32.4 17.47 32.4H16.3C13.5 32.4 11.2 30.11 11.2 27.3C11.2 24.49 13.38 22.35 16.08 22.24V19.8C16.08 19.4 16.41 19.07 16.81 19.07C17.21 19.07 17.54 19.4 17.54 19.8V22.24H21.44C21.84 22.24 22.17 22.57 22.17 22.97C22.17 23.37 21.84 23.7 21.44 23.7H16.31C14.31 23.7 12.67 25.34 12.67 27.3C12.67 29.26 14.31 30.94 16.31 30.94H17.48C20.28 30.94 22.58 33.2 22.58 36C22.58 38.8 20.32 41.02 17.56 41.1V43.5C17.56 43.9 17.27 44.23 16.83 44.23C16.43 44.23 16.1 43.9 16.1 43.5V41.1H16.09Z",
    fill: "#019EF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_9124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.11,
    height: 48.35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsCostRange);
export default __webpack_public_path__ + "static/media/whsCostRange.f5873f095c4c45573b4855774d84832a.svg";
export { ForwardRef as ReactComponent };